// GENERATED by scripts/farm_podworko.py fit — re-run it when the Podwórko pictures change.
// Each garage car's spot: the middle of its driveway pad, in PODWORKO_CANVAS display px.
export const PODWORKO_CAR_SPOTS = {
  1: [],
  2: [{ x: 919, y: 622 }],
  3: [{ x: 919, y: 622 }],
  4: [{ x: 919, y: 622 }],
  5: [{ x: 894, y: 582 }, { x: 993, y: 631 }],
};
